import { FC, useEffect } from 'react';
import { useGoogleMapContext } from '../../context/GoogleMapContext';

/* -------------------------------------------------------------------------------------------------
 * Component: GoogleMapGroundOverlay
 * -----------------------------------------------------------------------------------------------*/

interface GoogleMapGroundOverlayProps {
    url: string;
    bounds: google.maps.LatLngBounds | null | google.maps.LatLngBoundsLiteral;
    onClick?: () => void;
    // opts?: google.maps.GroundOverlayOptions | null;
}

const GoogleMapGroundOverlay: FC<GoogleMapGroundOverlayProps> = (props) => {
    const { url, bounds, onClick } = props;

    const { map } = useGoogleMapContext();

    useEffect(() => {
        if (!map) return;

        const groundOverlay = new google.maps.GroundOverlay(url, bounds, {
            map: map,
            clickable: true,
            opacity: 0.7,
        });

        // const rectangle = new google.maps.Rectangle({
        //     // strokeColor: '#FF0000',
        //     // strokeOpacity: 0.8,
        //     // strokeWeight: 2,
        //     // fillColor: '#FF0000',
        //     // fillOpacity: 0.35,
        //     map: map,
        //     bounds: bounds,
        //     editable: true,
        //     draggable: true,
        //     clickable: true,
        // });

        // rectangle.addListener('click', ({ domEvent, latLng }: any) => {
        //     console.log(latLng.toJSON());

        //     console.log(rectangle.getBounds().toJSON());
        // });

        // console.log(groundOverlay);

        groundOverlay.addListener('click', ({ domEvent, latLng }: any) => {
            onClick?.();
        });

        return () => {
            groundOverlay.setMap(null);
        };
    }, [bounds, map, onClick, url]);

    return null;
};

export default GoogleMapGroundOverlay;
